<!--
/**
  * 图片/视频预览组件
  * @author weili
  * @date 2023-05-25
   使用说明：
    listConfig  属性配置
        picContentWidth 最外部div宽度 默认 100%
        noShowTitle 是否显示标题  默认 false
        picWidth 图片div宽度 默认 100%
        imgStyle 图片宽高样式 默认 width: 1rem; height: 1rem;margin:0.1rem 0.1rem 0 0
    photosList  附件集合：filePath 路径、 createDate 创建时间
  */
-->
<template>
  <div>
    <el-dialog
      :append-to-body="true"
      :modal="false"
      title="视频"
      class="video-dialog"
      :visible.sync="dialogVisible"
      width="55%"
      :center="true"
      :lock-scroll="true"
      :show-close="false"
      @close="mixCancelDialog"
    >
      <div style="text-align:center;">
        <br>
        <video
          id="video1"
          :src="videoUrl"
          controls="controls"
          autoplay
          height="420px"
          style="margin-top:-15px;"
        />
      </div>
    </el-dialog>
    <div
      class="pic-content"
      :style="
        {width:listConfig.picContentWidth}"
    >
      <div
        v-if="!listConfig.noShowTitle&&listConfig.title"
        class="pic-title"
      >{{ listConfig.title }}</div>

      <span
        v-if="listConfigPhotosList.length>listConfig.limit"
        class="pic-icon"
        @click="previPic"
      >
        <button
          v-if="listConfigPhotosList.length>listConfig.limit"
          type="button"
          class="el-button el-button--primary is-circle"
        >
          <i class="el-icon-arrow-left" />
        </button>
        <span
          v-else
          style="float:left;margin-left:.05rem"
        />
      </span>
      <div
        v-else
        style="height:.005rem;width:.05rem;float:left;"
      />
      <div
        class="demo-image__preview"
        :style="{width:listConfig.picWidth}"
      >
        <div class="move-content cus-image">
          <template v-for="(item,index) in listConfigPhotosList">
            <el-image
              :key="index"
              :z-index="2000"
              :style="listConfig.imgStyle"
              :src="(!item.filePath.includes('videoCover.png')&&item.filePath.indexOf('.mp4')==-1&&item.filePath.indexOf('.mov')==-1)?(urlFile+ item.filePath): require('@/assets/images/videoCover.png')"
              :preview-src-list="listConfigPhotosList.map(e =>(!e.filePath.includes('videoCover.png')&&e.filePath.indexOf('.mp4')==-1&&e.filePath.indexOf('.mov')==-1)?(urlFile+ e.filePath): require('@/assets/images/videoCover.png'))"
              @click.stop="cusPreviewImage(item.createDate,item.index,item.filePath)"
            />

          </template>
          <span
            v-if="dnFlag"
            class="el-image-date el-image-viewer__download"
            :class="{elImageDate:!createDate}"
          >
            第<span>{{ previewIndex }}</span>张 (共:{{ listConfigPhotosList.length }}张) {{ createDate }}
          </span>

          <span
            v-if="dnFlag"
            class="el-image-viewer__btn el-image-viewer__close_btn"
            @click="closePre"
          >
            <i class="el-icon-close" />
          </span> 

          <span
            v-if="dnFlag"
            class="el-image-viewer__btn  el-image-viewer_prev"
            @click="previPic"
          ><i class="el-icon-arrow-left" /></span>

          <span
            v-if="dnFlag"
            class="el-image-viewer__btn el-image-viewer_next"
            @click="nextPic"
          ><i class="el-icon-arrow-right" /></span>

        </div>
        <div class="create-date-content">
          <div
            v-for="(item,index) in listConfigPhotosList"
            :key="index"
            class="create-date"
          >
            {{ item.createDate }}
          </div>
        </div>
      </div>
      <span
        v-if="listConfigPhotosList.length>listConfig.limit"
        class="pic-icon"
        @click="nextPic"
      >
        <button
          v-if="listConfigPhotosList.length>listConfig.limit"
          type="button"
          class="el-button arrow-right el-button--primary is-circle"
        >
          <i class="el-icon-arrow-right" />
        </button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EXPreview',
  props: {
    listConfig:{
        type: Object,
        default: () => ({
          picContentWidth: "100%",
          noShowTitle: false,
          picWidth: "100%",
          imgStyle: "width: 1rem; height: 1rem;margin:0.1rem 0.1rem 0 0;"
        })
    },  
    photosList: []
  },
  data () {
    return {
      listConfigPhotosList: [],
      oldPhotosList: [],
      previewIndex: null,
      isFirstClickVideo: false,
      createDate: null,
      dialogVisible: false,
      dnFlag: false,
      videoBtnName: '播放',
      dialogConfig: { fileType: '', dialogImageUrl: '' },
      urlFile: $config.rootUrl,
      videoUrl: ''
    }
  },
  watch: {
    photosList: function (val) {
      if (val && this.photosList) {
        this.oldPhotosList = JSON.parse(JSON.stringify(this.photosList))
        this.listConfigPhotosList = this.photosList.map((item, index) => {
          item.index = index
          item.videoUrl = item.filePath
          return item
        })
      }
    }
  },
  created () {
    if(this.photosList){
      this.oldPhotosList = JSON.parse(JSON.stringify(this.photosList))
      this.listConfigPhotosList = this.photosList.map((item, index) => {
        item.index = index
        item.videoUrl = item.filePath
        return item
      })
    }
  },
  destroyde(){
    this.photosList = []
  },
  methods: {
     // 获取遮罩层dom
     handleClickItem(filePath){
      var me = this
      setTimeout(function(){
            let domImageMask = document.querySelector(".el-image-viewer__wrapper");
            var closeBtn = document.querySelector('.el-image-viewer__close')
            if (filePath.indexOf('videoCover.png') != -1 || filePath.indexOf('.mp4') != -1 || filePath.indexOf('.mov') != -1) {
                if(domImageMask){
                  domImageMask.style.zIndex = 0;
                }
            }
            if (!domImageMask || !closeBtn) {
              return;
            }
            domImageMask.addEventListener("click", (e) => {
              if(e.target.parentNode.className == 'el-image-viewer__actions__inner') {
                return;  //如果点击底部菜单，不关闭
              }
              // 点击遮罩层时调用关闭按钮的 click 事件
              me.dnFlag = false
              me.dialogVisible = false
              closeBtn.click()
            });
      },300)
    },
    // 放大图的日期
    cusPreviewImage (date, index, filePath) {
      this.handleClickItem(filePath)
      if (filePath.indexOf('videoCover.png') != -1 || filePath.indexOf('.mp4') != -1 || filePath.indexOf('.mov') != -1) {
        this.showVideo(this.oldPhotosList[index].filePath, this.oldPhotosList[index].httpUrl)
        this.isFirstClickVideo = true
        this.dialogVisible = true
      }
      this.createDate = date
      this.previewIndex = parseInt(index) + 1
      this.dnFlag = true
    },
    // 放大图关闭
    closePre () {
      this.dnFlag = false
      this.dialogVisible = false
      document.querySelector('.el-image-viewer__close').click()
    },
    // 放大图的日期
    getPreviewDate () {
      if (this.dnFlag) {
        this.createDate = this.oldPhotosList[parseInt(this.previewIndex) - 1].createDate
        this.playVideo(parseInt(this.previewIndex) - 1)
      }
    },
    // 下一张
    nextPic () {
      this.previewIndex += 1
     
      if (this.previewIndex > this.listConfigPhotosList.length) {
        this.previewIndex = 1
      }

      this.listConfigPhotosList = this.listConfigPhotosList.map(
        (item, index) => {
          if (index != parseInt(this.listConfigPhotosList.length) - 1) {
            item = this.listConfigPhotosList[index + 1]
          } else {
            item = this.listConfigPhotosList[0]
          }
          return item
        }
      )
      this.getPreviewDate()
    },
    // 上一张
    previPic () {
      this.dialogVisible = false
      this.previewIndex--
      if (this.previewIndex == 0) {
        this.previewIndex = this.listConfigPhotosList.length
      }
      this.listConfigPhotosList = this.listConfigPhotosList.map(
        (item, index) => {
          if (index != 0) {
            item = this.listConfigPhotosList[index - 1]
          } else {
            item = this.listConfigPhotosList[
              parseInt(this.listConfigPhotosList.length) - 1
            ]
          }
          return item
        }
      )

      this.getPreviewDate()
    },
    playVideo (index) {
      if (this.oldPhotosList[index].filePath.indexOf('videoCover.png') != -1 || this.oldPhotosList[index].filePath.indexOf('.mp4') != -1 || this.oldPhotosList[index].filePath.indexOf('.mov') != -1) {
        this.videoUrl = this.urlFile + this.oldPhotosList[index].videoUrl
        this.showVideo(this.oldPhotosList[index].filePath, this.oldPhotosList[index].httpUrl)
        this.dialogVisible = true
      } else {
        this.dialogVisible = false
      }
      this.isFirstClickVideo = false
    },
    // 查看图片
    handlePictureCardPreview (file) {
      this.dialogConfig.fileType = this.getFileType(file)
      this.dialogConfig.dialogImageUrl =
        'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=2583035764,1571388243&fm=26&gp=0.jpg'
      this.dialogVisible = true
    },
    // 获取图片类型
    getFileType (file) {
      if (file.httpUrl) {
        const first = file.httpUrl.lastIndexOf('.')
        const namelength = file.httpUrl.length
        const filesuffix = file.httpUrl.substring(first + 1, namelength)
        return filesuffix
      } else {
        return ''
      }
    },
    showVideo (filePath, httpUrl) {
      console.log(this.urlFile, filePath, httpUrl)
      if (httpUrl) {
        this.videoUrl = httpUrl.startsWith('http') ? httpUrl : this.urlFile + httpUrl        
      } else {
        this.videoUrl = filePath.startsWith('http') ? filePath : this.urlFile + filePath
      }

      this.dialogVisible = true
    },
    playPause () {
      var myVideo = document.getElementById('video1')

      if (myVideo.paused) {
        myVideo.play()
      } else {
        myVideo.pause()
      }
    },
    mixCancelDialog () {
      if (this.isFirstClickVideo) {
        this.closePre()
      }
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dialog__body .formWrap {
  overflow: inherit;
}
.formWrap {
  margin-top: 0.16rem;
  /deep/ .el-image-viewer__close {
    color: #ffffff;
  }
}
.pic-content {
  float: left;
  &:last-child {
    margin-right: 0 !important;
  }
}
.pic-title {
  width: 0.25rem;
  height: 1.5rem;
  background: #2153c0;
  color: white;
  float: left;
  font-size: 0.16rem;
  padding: 0.15rem 0.05rem 0.05rem;
  line-height: 0.3rem;
}
.demo-image__preview {
  height: 1.55rem;
  float: left;

  .move-content {
    height: 1.1rem;
    overflow: hidden;
  }
  .create-date-content {
    height: 0.38rem;
    overflow: hidden;
    .create-date {
      float: left;
      // margin-top: 0.05rem;
      margin-left: 0.1rem;
      width: 1rem;
      line-height: 0.19rem;
    }
  }
}
.arrow-right {
  margin-left: -0.05rem !important;
}
.is-circle {
  float: left;
  margin: 0.48rem 0.05rem;
}
.pic-icon {
  // width: 50px;
  float: left;
  height: 1.1rem;
}
/deep/.el-image-viewer__canvas {
  margin: 0 auto;
  width: 88%;
  height: 87.5%;
}
.cus-image {
  width: 100%;
  height: 100%;
  // display: inline-block;
  display: flex;

  .el-image-viewer__download,
  .el-image-viewer__close_btn {
    top: 40px;
    right: 40px;
    width: 40px;
    height: 40px;
    font-size: 24px;
    color: #000;
    background-color: #f3f3f4;
    z-index: 30000; /* 如果该组件需要传递 z-index 的值，这个值也需要做成动态的 props */
    cursor: pointer;
    position: fixed;
  }
  .el-image-date,
  .elImageDate {
    width: auto !important;
    font-size: 0.18rem;
    top: 87.5%;
    right: 42.3%;
    text-align: center;
    line-height: 0.4rem;
    white-space: nowrap;
    background: none;
    z-index: 20000;
    padding: 0 0.05rem;
    color: white;
  }
  .elImageDate {
    right: 46.8% !important;
  }
  .el-image-viewer_prev {
    transform: translateY(-50%);
    left: 40px !important;
    text-indent: 2px;
  }
  .el-image-viewer_next {
    transform: translateY(-50%);
    right: 40px !important;
    text-indent: 2px;
  }
  .el-image-viewer_next, .el-image-viewer_prev{
    width: 44px;
    height: 44px;
    font-size: 24px;
    color: #000;
    background-color: #f3f3f4;
    top: 43%;
  }
  .el-image-viewer__btn {
    // position: absolute;
    z-index: 30000;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-radius: 50%;
    opacity: .8;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
}

  /deep/ .el-image-viewer__close,
  /deep/.el-image-viewer__prev,
  /deep/.el-image-viewer__next {
    opacity: 0;
  }
}
.video-dialog {
  margin: 0 auto;
  width: 86%;
}
</style>



// WEBPACK FOOTER //
// src/components/EXPreview/index.vue